import { useCallback, useState } from 'react';

export type QuickToolKind = 'plot' | 'polish' | 'summary' | 'inspiration';

/**
 * 创作面板轻量 AI 工具（对话式）：
 * - 点击工具按钮 → 进入工具对话模式（activeTool），指令作为首条消息自动发出，
 *   AI 在对话中回复，用户可继续追问；对话走写作模式现有消息流。
 * - 工具对话期间工具行只保留「会话历史」；对话关闭（标题栏 X）后自动恢复完整按钮。
 * - 写入类操作（润色选区、摘要字段）由用户直接在对话结果中处理或经 execute 审批链完成，
 *   本模块不再提供应用/审批按钮。
 */
export function useQuickTools() {
  const [activeTool, setActiveTool] = useState<QuickToolKind | null>(null);

  /** 进入工具对话（工具行据此收窄为「会话历史」） */
  const enterTool = useCallback((kind: QuickToolKind) => {
    setActiveTool(kind);
  }, []);

  /** 退出工具对话（对话关闭时由父组件调用，恢复完整工具行） */
  const exitTool = useCallback(() => {
    setActiveTool(null);
  }, []);

  return {
    activeTool,
    enterTool,
    exitTool,
  };
}
